import { cva, VariantProps } from "class-variance-authority";

import {
    aiLoadingIndicatorStyles,
    icon,
    label,
} from "./AILoadingIndicator.css";
import { AILoadingIndicatorIcon } from "./AILoadingIndicatorIcon";

const rootStyle = cva(aiLoadingIndicatorStyles.base, {
    variants: {
        layout: {
            horizontal: aiLoadingIndicatorStyles.layouts.horizontal,
            vertical: aiLoadingIndicatorStyles.layouts.vertical,
        },
    },
});

export interface AILoadingIndicatorProps {
    label: string;
    layout?: VariantProps<typeof rootStyle>["layout"];
}

export function AILoadingIndicator({
    label: labelText,
    layout = "horizontal",
}: AILoadingIndicatorProps) {
    return (
        <div className={rootStyle({ layout })}>
            <AILoadingIndicatorIcon className={icon} />
            <div className={label}>{labelText}</div>
        </div>
    );
}
